import React from 'react';
import RightSideDrawer from "../../../../../components/reusable/RightSideDrawer";
import DrawerSection from "../../../../../components/reusable/DrawerSection";
import DetailRow  from "../../../../../components/reusable/DetailRow";
import ActionButtons from "../../../../../utils/ActionButtons";
import BaseIcon from "../../../../../components/svg_icons/BaseIcon";
import LoadingSpinner from "../../../../../components/loaders/LoadingSpinner";
import "../../../../../css/pages/ca_pages/models/manage_client/ViewClientInfo.css";

const ViewClientInfo = ({ isOpen, loading, request, onClose }) => {
    const businessCount = request?.businesses?.length ?? 0;
    const businessText =
        businessCount <= 1
            ? `This client owns ${businessCount} business`
            : `This client owns ${businessCount} businesses`;

    return (
        <RightSideDrawer
            isOpen  = { isOpen }
            onClose = { onClose }
            width   = "520px"
        >
            { loading ? <LoadingSpinner /> : request ? (
                <>
                    {/* Header */}
                    <div className="client-info-header">
                        <div className="client-info-avatar">
                            {request.user_profile_image ?
                                <img
                                    src={request.user_profile_image}
                                    alt={request.user_full_name}
                                />
                            : <BaseIcon name="users" size={34} />
                            }
                        </div>

                        <div className="client-info-meta">
                            <h2>{request.user_full_name}</h2>
                            <p>{request.email}</p>
                            <span className="client-info-business-badge">
                                {businessText}
                            </span>
                        </div>
                    </div>

                    <DrawerSection title="Contact Information">
                        <DetailRow
                            label="Contact Number"
                            value={request.contact}
                        />

                        <DetailRow
                            label="Email"
                            value={request.email}
                        />
                    </DrawerSection>

                    {/* Footer */}
                    <div className="view-doc-request-footer">
                        <ActionButtons
                            actions={[
                                {
                                    buttonType: "cancel",
                                    onClick: onClose,
                                },
                                {
                                    buttonType: "viewOutline",
                                    customName: "Edit Record"
                                },
                            ]}
                        />
                    </div>
                </>
            ) : null}
        </RightSideDrawer>
    );
};

export default ViewClientInfo;
